import React from 'react';
import { Row, Col } from 'react-bootstrap';
import collaborators from '../images/Colaboradores.png';

function InfoCard({ title = '', subtitle = '', onRequest = false }) {
  return (
    <>
      {!onRequest && (
        <>
          <Row style={{ alignItems: 'center', paddingRight: 5, paddingLeft: 5, height: 85 }}>
            <Col xs={4} md={4} xl={4}>
              <img className="mb-2" src={collaborators} alt="collaborators.png" />
            </Col>
            <Col xs={8} md={8} xl={8}>
              <Row className="pl-3 pt-2">
                <p style={{ fontSize: '14px', fontWeight: 'bold', color: 'black', marginRight: 10 }}>
                  {title} {subtitle}
                </p>
              </Row>
            </Col>
          </Row>
        </>
      )}
    </>
  );
}

export default InfoCard;
